import { buildSlice, CommonState } from '~libs/reduxUtils';

import { SectionItem } from '~support-at-home/models';

import { getAll, getBudgetExternalServices, typePrefix } from '~support-at-home/actions/budgetServices';

interface State extends CommonState<SectionItem> {
  total: number;
  count: number;
}

const initialState: State = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  total: 0,
  count: 0,
};

const slice = buildSlice<State, SectionItem>(typePrefix, initialState, {
  extraReducers: (builder) => {
    builder.addCase(getAll.fulfilled, (state, action) => {
      state.loading = 'fulfilled';
      state.hasLoaded = true;
      state.rows = action.payload.data.rows ?? [];
      state.total = action.payload.data.total ?? 0;
      state.count = action.payload.data.count ?? 0;
    });
    builder.addCase(getBudgetExternalServices.fulfilled, (state, action) => {
      state.rows = action.payload.data;
      state.loading = 'fulfilled';
    });
  },
});

export const { clear } = slice.actions;
export default slice.reducer;
